import axios from 'axios';
import 'regenerator-runtime/runtime';
import logger from '../common/logger';

const SERVICE_URL = 'https://exclusive-domain-lookup.gu-api.com/';

const httpResponse = (res = {}) => {
  logger.info('', { res });
  return {
    headers: res.header || {},
    data: res.data || {},
    status: res.status || 0,
  };
};

const handleAxiosError = (error) => {
  logger.error('', { error });
  if (!error.response && !error.request) throw error;
  return error.response ? httpResponse(error.response) : httpResponse({ status: 500, data: { error: error.request } });
};

const AffiliateIdHttpClient = {
  getAffiliateIdAsync: (domain, environment = 'prod') => {
    return axios.get(`${SERVICE_URL}${domain}?environment=${environment}`).then(httpResponse, handleAxiosError);
  }
};
export default AffiliateIdHttpClient;